import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38b6bd4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "product-workarea__actions d-flex align-center mb-2"
}
const _hoisted_2 = { class: "product-workarea__zoom" }
const _hoisted_3 = { class: "product-workarea__image" }
const _hoisted_4 = {
  key: 0,
  class: "product-workarea__layers"
}

import { onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { v4 as uuidv4 } from 'uuid';
import { cloneDeep } from 'lodash';
import { useEventBus } from '@vueuse/core';

// import { urlToBase64 } from '@/helpers/urlToBase64';

import { useEditorStore } from '@/store/editor';
import { useCommonStore } from '@/store/common';
import { useServicesStore } from '@/store/services';

import { ICanvasImage } from '@/types/ICanvasImage';
// import { IImageData, IProduct } from '@/store/editor/types';
// import { IServiceImagesItem } from '@/types/IServiceImagesItem';

import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiCanvas from '@/components/UI/AiCanvas/AiCanvas.vue';
import AiDropLoader from '@/components/UI/AiDropLoader/AiDropLoader.vue';
import AiModal from '@/components/UI/AiModal/AiModal.vue';
import AiSceleton from '@/components/UI/AiSceleton/AiSceleton.vue';

import AddImage from '@/components/common/AddImage/AddImage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductWorkarea',
  setup(__props) {

const busError = useEventBus<string>('toast-error');

// const emits = defineEmits(['keyUpdate']);

const { generateImageData, aiCanvasRef } = storeToRefs(useEditorStore());
const { imageForActions } = storeToRefs(useServicesStore());
const { isMobile } = storeToRefs(useCommonStore());

const loading = ref<boolean>(false);
const activeProductId = ref<string | undefined>(undefined);
const activeProductUid = ref<string | undefined>(undefined);
const productsList = ref<ICanvasImage[]>([]);
const activeZoom = ref<number>(1);
const key = ref<number>(0);
const showAddingModal = ref<boolean>(false);

const canvasUpdateHandler = (productsData: {
  products: any[];
  activeProductId: any | null;
  activeProductUid: string;
}): void => {
  activeProductId.value = productsData.activeProductId;
  activeProductUid.value = productsData.activeProductUid;
  const productsUpdated: any = [];

  productsData.products.forEach((product: any) => {
    const resProduct = cloneDeep(
      productsList.value.find((productsListItem: any) => productsListItem.id === product.productId),
    );
    if (resProduct) {
      const productForUpdate = { ...product, image: resProduct.image, id: product.productId };
      productsUpdated.push(productForUpdate);
    }
  });
  productsList.value = [...productsUpdated];
  generateImageData.value.products = productsList.value as any;

  // productsList.value = [...productsData.products];
};

const removeProductHandler = (id: string | undefined): void => {
  if (productsList.value.length <= 1) {
    busError.emit('Нельзя удалить');
    return;
  }
  productsList.value = productsList.value.filter((p) => p.id !== id);
  key.value += 1;
};

const zoomInHandler = (): void => {
  activeZoom.value += 0.1;
};

const zoomOutHandler = (): void => {
  activeZoom.value -= 0.1;
};

const activeZoomSetHandler = (newVal: number): void => {
  activeZoom.value = newVal;
};

const toTopHandler = (): void => {
  const uid = activeProductUid.value;
  aiCanvasRef.value.moveForvard(uid);
};

const toBottomHandler = (): void => {
  const uid = activeProductUid.value;
  aiCanvasRef.value.moveBackward(uid);
};

const addProductModalToggleHandler = (): void => {
  showAddingModal.value = !showAddingModal.value;
};

onMounted(() => {
  // productsList.value = generateImageData.value.products as any;
  if (generateImageData.value.products.length) {
    const products = [...generateImageData.value.products];
    productsList.value = products;
  } else {
    generateImageData.value.products = [
      {
        image: imageForActions.value,
        id: uuidv4(),
        uid: uuidv4(),
        mask: false,
        transform: {
          x: null,
          y: 0,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
        },
      },
    ];
  }
});

watch(
  () => generateImageData.value.products,
  () => {
    const products = [...generateImageData.value.products];
    productsList.value = products;
    // products.forEach((product: IImageData, index: number) => {
    //   if (productsList.value[index]) {
    //     productsList.value[index].transform = { ...product.transform };
    //   }
    // });
  },
  { deep: true },
);

watch(imageForActions, (newVal) => {
  if (newVal !== '') {
    showAddingModal.value = false;
    generateImageData.value.products.push({
      image: newVal,
      id: uuidv4(),
      uid: uuidv4(),
      mask: false,
      transform: {
        x: null,
        y: 0,
        scaleX: 1,
        scaleY: 1,
        angle: 0,
      },
    });
    const products = [...generateImageData.value.products];
    productsList.value = products;
    key.value += 1;
  } else {
    generateImageData.value.products = [];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AiCard, {
      radius: 16,
      class: _normalizeClass(["product-workarea", { 'product-workarea--mobile': _unref(isMobile) }])
    }, {
      default: _withCtx(() => [
        (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(AiClearButton, {
                  class: "product-workarea__zoom__button",
                  "active-zoom": activeZoom.value,
                  onClick: zoomOutHandler
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_inline_svg, {
                      src: require('@/assets/icons/IconDecrease.svg')
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }, 8, ["active-zoom"]),
                _createVNode(AiClearButton, {
                  class: "product-workarea__zoom__button",
                  onClick: zoomInHandler
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_inline_svg, {
                      src: require('@/assets/icons/IconIncrease.svg')
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_v_spacer),
              _createVNode(AiClearButton, {
                onClick: addProductModalToggleHandler,
                class: "d-flex align-center product-workarea__action"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_inline_svg, {
                    src: require('@/assets/icons/menu/my-products.svg')
                  }, null, 8, ["src"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('editor.settings.add-product')), 1)
                ]),
                _: 1
              }),
              (activeProductId.value && productsList.value.length > 1)
                ? (_openBlock(), _createBlock(AiClearButton, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (removeProductHandler(activeProductId.value))),
                    class: "d-flex align-center product-workarea__action"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_inline_svg, {
                        src: require('@/assets/icons/clear.svg')
                      }, null, 8, ["src"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('common.delete')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (activeProductId.value && productsList.value.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(AiClearButton, {
                  class: "product-workarea__layers__button",
                  onClick: toTopHandler
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_inline_svg, {
                      src: require('@/assets/icons/canvas/to-top.svg')
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }),
                _createVNode(AiClearButton, {
                  class: "product-workarea__layers__button",
                  onClick: toBottomHandler
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_inline_svg, {
                      src: require('@/assets/icons/canvas/to-bottom.svg')
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!loading.value)
            ? (_openBlock(), _createBlock(AiCanvas, {
                key: key.value,
                images: productsList.value,
                disabled: _unref(generateImageData).loading,
                width: _unref(generateImageData).canvas.width,
                height: _unref(generateImageData).canvas.height,
                "active-zoom": activeZoom.value,
                onCanvasUpdate: canvasUpdateHandler,
                onDeleteProduct: removeProductHandler,
                onActiveZoomSet: activeZoomSetHandler,
                "reset-existing-image-transforms-on-change-images": false,
                "add-lines": "",
                ref_key: "aiCanvasRef",
                ref: aiCanvasRef
              }, null, 8, ["images", "disabled", "width", "height", "active-zoom"]))
            : (_openBlock(), _createBlock(AiSceleton, {
                key: 2,
                class: "product-workarea__sceleton"
              })),
          (_unref(generateImageData).loading)
            ? (_openBlock(), _createBlock(AiDropLoader, { key: 3 }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(AiModal, {
      "show-modal": showAddingModal.value,
      "handle-toggle": addProductModalToggleHandler
    }, {
      button: _withCtx(() => [
        _createVNode(AddImage, { "is-remove-bg": "" })
      ]),
      _: 1
    }, 8, ["show-modal"])
  ], 64))
}
}

})